import React from 'react';
import { useSystemTasks } from '../hooks/use-system-tasks.js';
import SystemTasksPageView from './system-tasks-page-view.jsx';

function SystemTasksPageContainer() {
  const state = useSystemTasks();
  return <SystemTasksPageView {...state} />;
}

export default SystemTasksPageContainer;
